import type { DBRecord } from '../services/PreferencesDB.ts';

export class Gratitude implements DBRecord {
  id: string = crypto.randomUUID();
  createdAt: number = Date.now();
  lastModified: number = Date.now();
  content: string = '';
  emoji: string = '❤️';

  toPlain(): object {
    return {
      id: this.id,
      createdAt: this.createdAt,
      lastModified: this.lastModified,
      content: this.content,
      emoji: this.emoji,
    };
  }

  // Common emoji options for gratitude entries
  static getEmojiOptions(): string[] {
    return [
      '❤️',
      '🙏',
      '✨',
      '😊',
      '🌟',
      '🌈',
      '🌻',
      '🌞',
      '🍀',
      '🦋',
      '🎁',
      '🏆',
      '🥰',
      '💫',
      '💖',
    ];
  }

  // Get a random daily prompt
  static getDailyPrompt(): string {
    const prompts = [
      'What made you smile today?',
      "One tiny thing you're thankful for?",
      "What's something beautiful you noticed today?",
      'Who made your day better today?',
      "What's something you're looking forward to?",
      "What's a simple pleasure you enjoyed today?",
      "What's something you love about your life right now?",
      "What's something that inspired you today?",
      "What's a challenge you're grateful for?",
      "What's something you appreciate about yourself today?",
    ];

    return prompts[Math.floor(Math.random() * prompts.length)];
  }
}
